import {
  RP_CONFIGURATION,
  RP_DATE,
  RP_EC_ID,
  RP_POD,
} from 'consts';
import ConfBlock from 'utils/ConfBlock';

// FILTERS
const dateFilterBlockNoDeps = new ConfBlock(RP_DATE);
const ecFilterBlockNoDeps = new ConfBlock(RP_EC_ID);
const configFilterBlockNoDeps = new ConfBlock(RP_CONFIGURATION);
const loadAreaBlockNoDeps = new ConfBlock(RP_POD);

export const dashboardFilter = [
  dateFilterBlockNoDeps,
  ecFilterBlockNoDeps,
  configFilterBlockNoDeps,
  loadAreaBlockNoDeps,
];

export const energyCommunityFilter = [
  dateFilterBlockNoDeps,
  ecFilterBlockNoDeps,
  configFilterBlockNoDeps,
  loadAreaBlockNoDeps,
];

// TABLE

const nameAndSurnameColumnBlock = new ConfBlock('membersField');
const timePeriodColumnBlock = new ConfBlock('timePeriodField');
const energyCommunityAddressColumnBlock = new ConfBlock('addressField');
const energyConsumptionColumnBlock = new ConfBlock('energyConsumptionField');
const dispatchedEnergyColumnBlockLocation = new ConfBlock('dispatchedEnergyField');
const sharedEnergyColumnBlockLocation = new ConfBlock('sharedEnergyField');
const rewardsColumnBlockNoDeps = new ConfBlock('totalRewardField');
const sharedRatioField = new ConfBlock('sharedRatioField');
const contemporaneityField = new ConfBlock('contemporaneityField');
const podFieldBlock = new ConfBlock('podField');

export const energyCommunityColumns = [
  nameAndSurnameColumnBlock,
  timePeriodColumnBlock,
  energyCommunityAddressColumnBlock,
  energyConsumptionColumnBlock,
  dispatchedEnergyColumnBlockLocation,
  rewardsColumnBlockNoDeps,
  sharedEnergyColumnBlockLocation,
  sharedRatioField,
  podFieldBlock,
  contemporaneityField,
];

// WIDGETS
const energyProductionWidgetBlock = new ConfBlock('energyProductionWidget');

const energyCommunityRewardsWidgetBlock = new ConfBlock('energyCommunityRewardsWidget');

const energyPerformanceWidgetBlock = new ConfBlock('energyPerformanceWidget');

const energyRankingWidgetBlock = new ConfBlock('energyRankingWidget');

export const dashboardWidgets = [
  energyProductionWidgetBlock,
  energyCommunityRewardsWidgetBlock,
  energyPerformanceWidgetBlock,
];

export const energyCommunityWidgets = [
  energyProductionWidgetBlock,
  energyCommunityRewardsWidgetBlock,
  energyRankingWidgetBlock,
];

// KPIS

const totalConsumptionKpiBlock = new ConfBlock('totalConsumptionKpi');

const totalGenerationKpiBlock = new ConfBlock('totalGenerationKpi');

const totalMembersKpiBlock = new ConfBlock('totalMembersKpi');

const totalSharedEnergyKpiBlock = new ConfBlock('totalSharedEnergyKpi');

const totalRevenueKpiBlock = new ConfBlock('totalRevenueKpi');

const saturationKpiKpiBlock = new ConfBlock('saturationKpi');

const healthKpiBlock = new ConfBlock('healthKpi');

const totalConfigurationsKpiBlock = new ConfBlock('totalConfigurationsKpi');

const totalPlantsKpiBlock = new ConfBlock('totalPlantsKpi');

const totalPowerKpiBlock = new ConfBlock('totalPowerKpi');

const savedCO2KpiBlock = new ConfBlock('savedCO2Kpi');

const lastMeasuredUpdateKpiBlock = new ConfBlock('lastMeasuredUpdateKpi');

const lastEstimatedUpdateKpiBlock = new ConfBlock('lastEstimatedUpdateKpi');

const lastFiscalUpdateKpiBlock = new ConfBlock('lastFiscalUpdateKpi');

export const dashboardKpis = [
  totalConsumptionKpiBlock,
  totalGenerationKpiBlock,
  totalMembersKpiBlock,
  totalSharedEnergyKpiBlock,
  totalRevenueKpiBlock,
  saturationKpiKpiBlock,
  healthKpiBlock,
  totalConfigurationsKpiBlock,
  totalPlantsKpiBlock,
  totalPowerKpiBlock,
  savedCO2KpiBlock,
  lastMeasuredUpdateKpiBlock,
  lastEstimatedUpdateKpiBlock,
  lastFiscalUpdateKpiBlock,
];
